module.exports = __webpack_public_path__ + "media/images/step_06-38b77ecdc241c0a9b2a11d58693b7560.gif";